// 根据lessonid跳转直播间
export default {
  data() {
    return {
      joinLessonId: null,
      joinCourseId: null,
      joinCourseType: null,
    };
  },
  methods: {
    joinLiveRoomByLessonId(lesson_id) {
      let data = this.$store.state?.classReminder?.lessonList[lesson_id] || {};
      console.log(
        data,
        this.$store.state?.classReminder,
        "joinLiveRoomByLessonId--get-data==================="
      );

      // 删除
      this.$store.commit("classReminder/delLessonList", lesson_id);
      this.$nextTick(() => {
        if (data.isAssistant) {
          setTimeout(() => {
            this.changeTab(1);
          }, 0);
        }
        if (data.isStudent) {
          data.id = data.lesson_id;
        }
        // 群聊-老师-创建直播间
        if (JSON.stringify(data) === "{}") {
          data = {
            course_id: this.joinCourseId,
            lesson_id: this.joinLessonId,
            course_type: this.joinCourseType,
          };
        }
        console.log(data, "data-join-room-data=====");
        this.goLiveRoom(data);
      });
    },
  },
  watch: {
    "$route.query": {
      immediate: true,
      handler(newValue) {
        if (newValue?.lesson_id) {
          console.log(
            newValue?.lesson_id,
            newValue?.course_id,
            newValue?.course_type,
            "data============lesson_id,course_id,course_type===="
          );
          this.joinLessonId = newValue?.lesson_id;
          this.joinCourseId = newValue?.course_id;
          this.joinCourseType = newValue?.course_type;
          this.$router.replace({
            query: {
              ...this.$route.query,
              lesson_id: "",
              course_id: "",
            },
          });
          this.joinLiveRoomByLessonId(Number(newValue?.lesson_id));
        }
      },
    },
  },
};
